import i18n from 'i18next'
import Backend from 'i18next-xhr-backend'
import { initReactI18next } from 'react-i18next'

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: 'en',
    backend: {
      // translation file path 
      loadPath: 'assets/i18n/{{ns}}/{{lng}}.json'
    },
    fallbackLng: 'fr',
    debug: true,
    // can have multiple namespace, in case you want to divide a huge translation into smaller pieces and load them on demand 
    ns: ['translations'],
    defaultNS: 'translations',
    keySeparator: false,
    interpolation: {
      escapeValue: false,
      formatSeparator: ','
    },
    react: {
      wait: true
    }
  })

  /*i18n
  .use(Backend)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  .init({
    fallbackLng: 'en',
    debug: true,
    interpolation: {
        format: function(value, format, lng) {
          console.log(value,format,'here');
            if (format === ',') return value.replace(',','.');
            if(value instanceof Date) return moment(value).format(format);
            return value;
        },
         escapeValue: false,
    },
    react: {
      bindI18n: 'languageChanged',
      bindI18nStore: '',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
      useSuspense: false,
    }
  });*/

export default i18n
